// "Website $12 + domain $X = $Y/yr" — the total is always stated.
export function priceLine(r, website = 12) {
  const total = Number(r?.website_price);
  if (!Number.isFinite(total)) return '';
  const domain = Number(r?.register_price ?? (total - website));
  return `Website $${website} + domain $${domain} = $${total}/yr`;
}
